import { GetServerSidePropsContext } from 'next';
import Link from 'next/link';
import React from 'react';
import Container from '../../components/container/container.component';
import NoLatestNews from '../../components/latest-news/no-latest-news/no-latest-news.component';
import SectionTitle from '../../components/section-title/section-title.component';
import { getGalleries } from '../../lib';
import Page from '../../templates/page.template';
import { GalleriesListProps } from '../../types/galleries-list-props.interface';

interface Props extends GalleriesListProps { }

const GalleryListPage: React.FC<Props> = ({ menu, options, galleries }) => {
  const backgroundSize = (img?: any) => {
    if (img) {
      if (img.width > img.height) {
        return 'auto 100%';
      } else {
        return '100% auto';
      }
    }
    return 'auto';
  };
  return (
    <Page
      menu={menu}
      options={options}
      title="Galleries"
      description={options.description}
    >
      <Container column={true} css={{ marginTop: '40px' }}>
        <SectionTitle title="Galleries" />
        {galleries.length ? (
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {galleries.map((gallery) => (
              <div key={gallery.id} className="galleryItem">
                <Link href={`/gallery/${gallery.slug}`}>
                  <a
                    style={{
                      position: 'relative',
                      textDecoration: 'none',
                      color: '#fffbee',
                    }}
                  >
                    <div
                      className="tiles__itemimage"
                      style={{
                        backgroundImage: gallery.cover
                          ? `url(${options.baseUrl}${gallery.cover.image.url})`
                          : '',
                        backgroundSize: backgroundSize(
                          gallery.cover ? gallery.cover.image : null
                        ),
                      }}
                    >
                      {/* {gallery.cover && (
                        <img
                          src={`${options.baseUrl}${gallery.cover.image.url}`}
                          alt={gallery.title}
                          style={{ objectFit: 'contain' }}
                        />
                      )} */}
                    </div>
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '5px',
                        right: '5px',
                      }}
                    >
                      <h3 style={{ textAlign: 'right', fontSize: '24px' }}>
                        {gallery.title}
                      </h3>
                    </div>
                  </a>
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <NoLatestNews category="gallery" />
        )}
      </Container>
    </Page>
  );
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const { menu, options, galleries } = await getGalleries();

  ctx.res.setHeader('Cache-Control', 'public, max-age=300, s-maxage=300');

  return { props: { menu, options, galleries } };
}

export default GalleryListPage;
